module.exports = __webpack_public_path__ + "media/landshark.8ff7bca9.webm";